import blog from "./blog"
import critics from "./critics"
import eightLeggedFreak from "./eightLeggedFreak"
import forum from "./forum"
import homeVideoReviews from "./homeVideoReviews"
import homeVideos from "./homeVideos"
import news from "./news"
import socials from "./socials"
import vendors from "./vendors"

export default {
  blog,
  critics,
  eightLeggedFreak,
  forum,
  homeVideoReviews,
  homeVideos,
  news,
  socials,
  vendors
}
